const userTypes = {
  FETCH_USER_START: "FETCH_USER_START",
  FETCH_USER_SUCCESS: "FETCH_USER_SUCCESS",

  SET_USER_TOKEN: "SET_USER_TOKEN",

  SET_USER_IS_CONNECTED: "SET_USER_IS_CONNECTED",

  CLEAR_USER: "CLEAR_USER",
};

export default userTypes;
